/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 11:34:56
 * @LastEditors: jing
 * @LastEditTime: 2021-04-08 10:47:59
 * @Description: file content
 * requiresAuth 0静默授权 1用户授权 2 无需授权 
 */
import MyRouter from "@/routers/act-wxauth";
import config from "./config";
let myRouter = new MyRouter({
  fake: config.env[process.env.VUE_APP_SERVE_ENV].routersActWxauth.fake,
  // servicesActWxjssdk: config.env[process.env.VUE_APP_SERVE_ENV].servicesActWxjssdk
});

myRouter.router.addRoutes([{
    path: "/writeoff",
    name: "writeoff",
    meta: {
      title: "核销",
      requiresAuth: 1
    },
    component: () => import("./writeoff.vue")
  },
  {
    path: "/layout",
    name: "layout",
    meta: {
      title: "",
      requiresAuth: 2
    },
    component: () => import("./layout.vue"),
    children: [{
        path: "/index",
        name: "index",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () => import("./index.vue")
      },
      {
        path: "/examine",
        name: "examine",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 2
        },
        component: () => import("./examine.vue")
      },
      {
        path: "/draw",
        name: "draw",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () => import("./draw.vue")
      },
      {
        path: "/dzp",
        name: "dzp",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () => import("./dzp.vue")
      },
      {
        path: "/bird",
        name: "bird",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () => import("./bird.vue")
      },
      {
        path: "/rules",
        name: "rules",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () =>
          import("./rules.vue")
      },
      {
        path: "/myprize",
        name: "myprize",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () =>
          import("./myprize.vue")
      },
      {
        path: "/ranking",
        name: "ranking",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () =>
          import("./ranking.vue")
      },
      {
        path: "/birdranking",
        name: "birdranking",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () =>
          import("./birdRanking.vue")
      },
      {
        path: "/myFriends",
        name: "myFriends",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () =>
          import("./myFriends.vue")
      },
      {
        path: "/coupon",
        name: "coupon",
        meta: {
          title: '澳小拉与你燃情欧洲杯',
          requiresAuth: 1
        },
        component: () =>
          import("./coupon.vue")
      },
      {
        path: "/voice",
        name: "voice",
        meta: {
            title: '澳小拉与你燃情欧洲杯',
            requiresAuth: 1
        },
        component: () =>
            import("./voice.vue")
      },
      {
        path: "/share",
        name: "share",
        meta: {
            title: '澳小拉与你燃情欧洲杯',
            requiresAuth: 1
        },
        component: () =>
            import("./share.vue")
      },
    ]
  }
])
export default myRouter.router;